<template>
  <v-row>
    <v-overlay :value="loadingContrat" :absolute="true" :opacity="1"
      >Chargement ... Veuillez patienter
      <v-progress-linear color="blue" indeterminate rounded height="25">
      </v-progress-linear>
    </v-overlay>

    <v-col>
      <v-select
        v-if="DRHs"
        :items="DRHs"
        :label="user.displayName"
        item-text="nomPrenomGestionnaire"
        v-model="DRH"
        @change="changerDRH"
        item-value="uidGestionnaire"
        single-line
        clearable
      ></v-select>
      <v-progress-circular
        v-else
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-col>
    <v-col cols="12" md="12">
      <v-data-table
        :headers="headers"
        :items="filteredDemandes"
        class="elevation-1"
        pagination.sync="pagination"
        :loading="loading"
        search
      >
        <template v-slot:[`header.nomPrenom`]="{ header }">
          {{ header.text }}
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon slot="activator" v-bind="attrs" v-on="on">
                <v-icon small :color="filterNomPrenom ? 'info' : ''"
                  >mdi-filter</v-icon
                >
              </v-btn>
            </template>
            <v-card class="block">
              <v-text-field
                v-model="filterNomPrenom"
                label="entrer un élément de recherche"
              >
              </v-text-field>
              <v-btn color="error" small text @click="filterNomPrenom = null"
                >Annuler
              </v-btn>
            </v-card>
          </v-menu>
        </template>
        <template v-slot:[`header.validation`]="{ header }">
          {{ header.text }}
          <v-menu offset-y click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon slot="activator" v-bind="attrs" v-on="on"
                ><v-icon small :color="filterValide ? 'info' : ''"
                  >mdi-filter</v-icon
                ></v-btn
              >
            </template>
            <v-list>
              <v-checkbox
                dense
                label="en cours"
                v-model="filterValide"
                :value="null"
              ></v-checkbox>
              <v-checkbox
                dense
                label="accepté"
                v-model="filterValide"
                :value="true"
              ></v-checkbox>
              <v-checkbox
                dense
                label="refusé"
                v-model="filterValide"
                :value="false"
              ></v-checkbox>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`item.typeSouscription`]="{ item }">
          <v-col>{{
            refTypeSouscription[item.typeSouscription - 1].name
          }}</v-col>
        </template>
        <template v-slot:[`item.debutContrat`]="{ item }">
          <v-col>{{
            item.debutContrat
              ? new Date(item.debutContrat).toLocaleString("fr-FR", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : ""
          }}</v-col>
        </template>
        <template v-slot:[`item.cotisationParEmployeur`]="{ item }">
          <v-col v-if="item.cotisationParEmployeur == true">Oui</v-col>
          <v-col v-else-if="item.cotisationParEmployeur == false">Non</v-col>
        </template>
        <template v-slot:[`item.nameFile`]="{ item }">
          <v-btn v-if="item.nameFile != null" icon @click="afficherPDF(item)"
            ><v-icon color="green">mdi-book-open-variant</v-icon></v-btn
          >
        </template>
        <template v-slot:[`item.validation`]="{ item }">
          <v-col v-if="item.validation == null" color="warning">
            <v-btn
              color="warning"
              @click="openValidation(item)"
              rounded
              outlined
              small
              >A valider &nbsp;<v-icon small
                >mdi-checkbox-marked-circle-outline</v-icon
              ></v-btn
            >
          </v-col>
          <v-chip v-else-if="item.validation == 0" color="error">refusé</v-chip>
          <v-chip v-else-if="item.validation == 1" color="success"
            >accepté</v-chip
          >
        </template>
        <template v-slot:[`item.etat`]="{ item }">
          <div class="font-weigth-bold">
            <v-chip color="grey">{{ item.etat }}</v-chip>
          </div>
        </template>
        <template v-slot:[`item.messagerie`]="{ item }">
          <v-col>
            <v-badge
              :color="
                item.nombreMessagesGestionnaire <= 0 ? 'transparent' : 'primary'
              "
              :content="item.nombreMessagesGestionnaire"
            >
              <v-btn
                icon
                @click="lancerMessagerie(item)"
                :color="item.nombreMessagesGestionnaire > 0 ? 'red' : 'grey'"
                ><v-icon>chat</v-icon></v-btn
              >
            </v-badge>
          </v-col>
        </template>
        <template v-slot:[`item.messageRefus`]="{ item }">
          <v-tooltip
            bottom
            color="red"
            max-width="150px"
            v-if="item.messageRefus"
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs">{{ item.messageRefusPetit }}</span>
            </template>
            <span>{{ item.messageRefus }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-dialog
        v-model="popUpValidation"
        persistent
        :overlay="false"
        max-width="1500px"
        transition="dialog-transition"
      >
        <BaseBlock
          title="Validation du formulaire pour le remboursement partiel de la complémentaire santé"
        >
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-alert
              v-if="error.messages"
              border="left"
              type="error"
              elevation="2"
            >
              <template>
                <span
                  v-for="(errorMessage, index) in error.messages"
                  :key="index"
                >
                  {{ errorMessage }}
                  <br />
                </span>
              </template>
            </v-alert>
            <div class="text-center">
              <v-chip>{{ affichageEtat }}</v-chip>
            </div>
            <br />
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="formComplementaire.nomComplementaire"
                  label="nom Complémentaire Santé"
                  :rules="[(value) => !!value || 'Champ requis.']"
                  required
                  :disabled="disabledForm"
                ></v-text-field>
                <v-radio-group
                  v-model="formComplementaire.typeSouscription"
                  :rules="[(value) => !!value || 'Champ requis.']"
                  required
                  :disabled="disabledForm"
                >
                  Type de Souscription

                  <v-radio
                    v-for="type in refTypeSouscription"
                    :key="type.id"
                    :label="type.name"
                    :value="type.id"
                  ></v-radio>
                </v-radio-group>
                <v-radio-group
                  v-if="formComplementaire.typeSouscription == '2'"
                  v-model="formComplementaire.cotisationParEmployeur"
                  :disabled="disabledForm"
                  :rules="[(value) => value != null || 'Champ requis.']"
                  required
                >
                  cotisation par l'employeur
                  <v-radio label="Oui" :value="true"></v-radio>
                  <v-radio label="Non" :value="false"></v-radio>
                </v-radio-group>
                <v-menu
                  v-model="showCalendarDebut"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="formatedDateDebut"
                      label="Date d'effet"
                      prepend-icon="event"
                      readonly
                      clearable
                      v-on="on"
                      required
                      :rules="[(value) => !!value || 'Champ requis.']"
                      :disabled="disabledForm"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="fr-fr"
                    type="month"
                    v-model="formComplementaire.debutContrat"
                    @input="showCalendarDebut = false"
                    :max="
                      new Date(
                        Date.now() - new Date().getTimezoneOffset() * 60000
                      )
                        .toISOString()
                        .substr(0, 10)
                    "
                    :min="minimumDate().toISOString().substr(0, 10)"
                  ></v-date-picker>
                </v-menu>
                <v-file-input
                  label="Attestation de la complémentaire santé"
                  accept=".pdf, .png, .jpg, .jpeg"
                  v-model="file"
                  :rules="[
                    (value) =>
                      (!!value &&
                        /^.+\.(pdf|png|jpg|jpeg)$/.test(
                          value.name.toLowerCase()
                        )) ||
                      'Champ requis.',
                  ]"
                  :disabled="true"
                  v-if="affichagePDF"
                >
                </v-file-input>
                <div class="text-center">
                  <v-btn
                    class="mx-2"
                    :disabled="!valid || disabledForm"
                    color="success"
                    @click="validerFormComplementaire"
                    :loading="loading"
                  >
                    <v-icon left>mdi-magnify</v-icon>Valider
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    @click="annuler"
                    color="warning"
                    :disabled="disabledForm"
                    :loading="loading"
                  >
                    <v-icon left>mdi-refresh</v-icon>Annuler</v-btn
                  >
                  <v-btn
                    class="mx-2"
                    @click="modifierValidation"
                    color="warning"
                    :disabled="!disabledForm"
                    :loading="loading"
                  >
                    <v-icon left>mdi-circle-edit-outline</v-icon>Modifier
                  </v-btn>
                </div>
              </v-col>
              <v-col align="center" justify="center" v-if="affichagePDF">
                <iframe
                  height="100%"
                  width="100%"
                  :src="iframeSrc"
                  title="document pdf"
                  style="background: #ffffff"
                ></iframe>
              </v-col>
            </v-row>
            <v-row align="center" justify="center"
              ><div clas="text-center" v-if="!finForm">
                <v-col align-self="end">
                  <v-btn color="success" @click="dialogLots = true"
                    >Accepter</v-btn
                  >&nbsp;
                  <v-btn color="error" @click="dialogRefus = true"
                    >Refuser</v-btn
                  >
                  &nbsp;
                  <v-btn @click="fermerDialogValidation" color="info"
                    ><v-icon>mdi-close</v-icon>Fermer</v-btn
                  >
                </v-col>
              </div>
              <div v-else>
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular></div
            ></v-row>
          </v-form>
        </BaseBlock>
      </v-dialog>

      <v-dialog v-model="dialogRefus" persistent>
        <BaseBlock>
          <v-form v-model="validRefus" ref="formRefus" lazy-validation>
            <v-textarea
              v-model="formComplementaire.messageRefus"
              name="Expliquer le refus de la demande"
              label="Expliquez le refus de la demande"
              :rules="[
                (value) => !!value || 'Champ requis.',
                (v) =>
                  (v || '').length <= 4000 ||
                  `le nombre de caractères doit être inférieur à 4000.`,
              ]"
              required
              auto-grow
              counter="4000"
            ></v-textarea>
            <v-row align="center" justify="center"
              ><div clas="text-center">
                <v-col align-self="end">
                  <v-btn
                    color="success"
                    @click="confirmerDialogRefus"
                    :disabled="!validRefus"
                    >Valider</v-btn
                  >
                  <v-btn color="error" @click="annulerRefus">annuler</v-btn>
                </v-col>
              </div></v-row
            >
          </v-form>
        </BaseBlock>
      </v-dialog>
      <v-dialog v-model="dialogLots" persistent v-if="lots">
        <BaseBlock>
          <v-form v-model="validLot" ref="formLot" lazy-validation>
            <v-select
              :items="lots"
              v-model="formComplementaire.lot"
              label="choix du lot"
              clearable
              item-text="libelle"
              item-value="id"
              auto-grow
              :rules="[(value) => !!value || 'Champ requis.']"
              required
            ></v-select>
            <v-row align="center" justify="center"
              ><div clas="text-center">
                <v-col align-self="end">
                  <v-btn
                    color="success"
                    @click="confirmerDialogLot"
                    :disabled="!validLot"
                    >Valider</v-btn
                  >
                  <v-btn color="error" @click="annulerLot">annuler</v-btn>
                </v-col>
              </div></v-row
            >
          </v-form>
        </BaseBlock>
      </v-dialog>
    </v-col>
    <v-col>
      <v-dialog
        v-model="dialogPDF"
        max="100%"
        @click:outside="iframeSrc = null"
      >
        <BaseBlock>
          <v-responsive height="500px"
            ><iframe
              height="100%"
              width="100%"
              :src="iframeSrc"
              title="document PDF"
            ></iframe></v-responsive
          ><br />
          <div class="text-center">
            <v-btn color="info" @click="dialogPDF = false">fermer</v-btn>
          </div>
        </BaseBlock>
      </v-dialog>
    </v-col>

    <messagerie ref="messagerie" :temoinGestionnaire="true"></messagerie>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import moment from "moment";
import ApiFormComplementaireRepository from "@/repositories/ApiFormComplementaireRepository";
import ApiGestionnaireRepository from "@/repositories/ApiGestionnaireRepository";
import { mapState } from "vuex";
import ApiFormComplementaireLotRepository from "@/repositories/ApiFormComplementaireLotRepository";
import ApiIndividuRepository from "@/repositories/ApiIndividuRepository";
import messagerie from "@/components/Messagerie.vue";

export default {
  name: "DRHComplementaire",
  components: { BaseBlock, messagerie },
  extends: BaseForm,
  data() {
    return {
      headers: [
        {
          text: "Numéro",
          value: "id",
        },
        {
          text: "Demandeur",
          value: "nomPrenom",
          align: "start",
        },
        {
          text: "Nom de la complémentaire Santé",
          value: "nomComplementaire",
          align: "start",
        },
        { text: "Type de souscription", value: "typeSouscription" },
        {
          text: "Cotisation par l'employeur ?",
          value: "cotisationParEmployeur",
        },
        { text: "Date d'effet", value: "debutContrat" },

        { text: "Fichier joint", value: "nameFile" },
        { text: "Etat", value: "etat" },
        { text: "Statut", value: "validation" },
        {
          text: "Messagerie",
          value: "messagerie",
        },
        { text: "Message de refus", value: "messageRefus" },
      ],
      demandes: [],
      filterValide: [null],
      filterNomPrenom: null,
      formComplementaire: {
        nomComplementaire: null,
        typeSouscription: null,
        cotisationParEmployeur: null,
        debutContrat: null,
        finContrat: null,
        nameFile: null,
        validation: null,
        nomPrenom: null,
        noSIRH: null,
        messageRefus: null,
        lot: null,
      },
      formComplementaireSave: {
        nomComplementaire: null,
        typeSouscription: null,
        cotisationParEmployeur: null,
        debutContrat: null,
        finContrat: null,
        nameFile: null,
        validation: null,
        nomPrenom: null,
        noSIRH: null,
        messageRefus: null,
        lot: null,
      },
      valid: true,
      validRefus: true,
      validLot: true,
      refTypeSouscription: null,
      dialog: false,
      dialogPDF: false,
      editedIndex: -1,
      showCalendarDebut: false,
      showCalendarFin: false,
      message: null,
      hasResultats: false,
      loading: false,
      DRHs: null,
      DRH: null,
      popUpValidation: false,
      disabledForm: true,
      dialogRefus: false,
      iframeSrc: "",
      lots: null,
      dialogLots: false,
      lot: null,
      finForm: false,
      dateContratAgent: null,
      affichageEtat: null,
      affichagePDF: true,
      loadingContrat: false,
    };
  },
  computed: {
    filteredDemandes() {
      var conditions = [];

      conditions.push(this.filterValidation);

      if (this.filterNomPrenom) {
        conditions.push(this.filtrageNomPrenom);
      }

      if (conditions.length > 0) {
        return this.demandes.filter((demande) => {
          return conditions.every((condition) => {
            return condition(demande);
          });
        });
      }

      return this.demandes;
    },

    file() {
      return this.formComplementaire.nameFile != null
        ? new File([], this.formComplementaire.nameFile)
        : new File([], null);
    },

    formatedDateDebut() {
      if (this.formComplementaire.debutContrat < "2022-01") {
        return "2022-01-01" ? moment("2022-01-01").format("DD/MM/YYYY") : "";
      }

      return this.formComplementaire.debutContrat
        ? moment(this.formComplementaire.debutContrat).format("DD/MM/YYYY")
        : "";
    },
    formatedDateFin() {
      return this.formComplementaire.finContrat
        ? moment(this.formComplementaire.finContrat).format("DD/MM/YYYY")
        : "";
    },
    ...mapState(["user", "isAdmin"]),
  },
  async created() {
    if (sessionStorage.formComplementaire) {
      this.formComplementaire = JSON.parse(sessionStorage.formComplementaire);
    }
    this.refTypeSouscription =
      await ApiFormComplementaireRepository.getRefTypeSouscriptions();
    this.demandes =
      await ApiFormComplementaireRepository.getDemandesGestionnaire();
    this.DRHs = await ApiGestionnaireRepository.getGestionnaires();
    this.lots =
      await ApiFormComplementaireLotRepository.getLotsByDRHLotOuvert();
  },
  watch: {
    "formComplementaire.typeSouscription": function (val) {
      if (val == 1) {
        this.formComplementaire.cotisationParEmployeur = null;
      }
    },
    demandes: function () {
      this.demandes.forEach((demande) => {
        if (demande.messageRefus != null) {
          demande.messageRefusPetit = demande.messageRefus.substr(0, 20);
          return demande.messageRefusPetit + demande.messageRefus.length > 20
            ? "..."
            : "";
        }
        return null;
      });
    },
  },
  methods: {
    async validerFormComplementaire() {
      if (this.$refs.form.validate()) {
        if (this.formComplementaire.debutContrat < "2022-01-01") {
          this.formComplementaire.debutContrat = "2022-01-01";
        } else if (this.formComplementaire.debutContrat.length < 8) {
          this.formComplementaire.debutContrat =
            this.formComplementaire.debutContrat.concat("-01");
        }

        await ApiFormComplementaireRepository.updateDemande(
          this.formComplementaire
        );
        this.demandes[this.editedIndex] = Object.assign(
          {},
          this.formComplementaire
        );

        this.filterValide = [null];

        this.disabledForm = true;
      }
    },
    annuler() {
      Object.assign(this.formComplementaire, this.formComplementaireSave);
      this.disabledForm = true;
    },
    formOn() {
      this.dialog = true;
    },
    validationForm(valider) {
      if (this.disabledForm) {
        this.$confirm(
          "<b>Confirmez vous votre choix de " +
            (valider == "0" ? "refuser" : "valider") +
            " la demande ?</b>"
        ).then(async (reponse) => {
          if (reponse) {
            this.finForm = true;
            this.$toast.info("Vous avez confirmé.");

            if (valider == 1) {
              this.formComplementaire.validation = 1;
            } else this.formComplementaire.validation = 0;
            this.loading = true;
            this.$toast.info("envoi du mail en cours...");

            let updateDemande =
              await ApiFormComplementaireRepository.updateDemande(
                this.formComplementaire
              );
            this.finForm = false;
            this.loading = false;
            Object.assign(this.demandes[this.editedIndex], updateDemande);
            this.editedIndex = -1;
            this.formComplementaire = Object.assign({});
            this.$toast.info("Demande mise à jour.");
            this.popUpValidation = false;
            this.iframeSrc = "";
          } else {
            this.$toast.info("Vous n'avez pas confirmé.");
          }
          if (this.$refs.formRefus) {
            this.$refs.formRefus.reset();
          }
          if (this.$refs.formLot) {
            this.$refs.formLot.reset();
          }
          this.dateContratAgent = null;
          this.affichagePDF = true;
        });
      } else {
        this.$toast.warn("Veuillez valider le formulaire.");
      }
    },
    filterValidation(item) {
      return this.filterValide.includes(item.validation);
    },
    async changerDRH() {
      if (this.DRH != null) {
        this.loading = true;
        this.demandes = [];
        this.lots = [];
        this.demandes =
          await ApiFormComplementaireRepository.getDemandesGestionnaireByUid(
            this.DRH
          );
        this.lots =
          await ApiFormComplementaireLotRepository.getLotsByDRHGLotOuvert(
            this.DRH
          );
        this.loading = false;
      } else {
        this.demandes =
          await ApiFormComplementaireRepository.getDemandesGestionnaire();
      }
    },

    async openValidation(item) {
      this.affichageEtat = item.etat;
      if (this.affichageEtat == "SUPPRESSION") {
        this.affichagePDF = false;
      }
      this.loadingContrat = true;
      this.dateContratAgent = await ApiIndividuRepository.getDRHDateContrat(
        item.noSIRH
      );
      this.editedIndex = this.demandes.indexOf(item);
      this.formComplementaire = Object.assign({}, item);

      this.iframeSrc = await ApiFormComplementaireRepository.getDemandeFileDRH(
        item.id
      );
      this.popUpValidation = true;
      this.loadingContrat = false;
    },

    modifierValidation() {
      Object.assign(this.formComplementaireSave, this.formComplementaire);
      this.disabledForm = false;
    },

    fermerDialogValidation() {
      if (!this.disabledForm) {
        this.$toast.warn("Veuillez valider le formulaire.");
      } else {
        this.iframeSrc = "";
        this.popUpValidation = false;
        if (this.$refs.formRefus) {
          this.$refs.formRefus.reset();
        }
        if (this.$refs.formLot) {
          this.$refs.formLot.reset();
        }
        this.affichagePDF = true;
      }
    },

    confirmerDialogRefus() {
      if (this.$refs.formRefus.validate()) {
        this.dialogRefus = false;
        this.validationForm(0);
      }
    },
    confirmerDialogLot() {
      if (this.$refs.formLot.validate()) {
        this.dialogLots = false;
        this.validationForm(1);
      }
    },
    annulerRefus() {
      this.formComplementaire.messageRefus = null;
      this.$refs.formRefus.reset();
      this.dialogRefus = false;
    },
    annulerLot() {
      this.formComplementaire.lot = null;
      this.$refs.formLot.reset();
      this.dialogLots = false;
    },
    filtrageNomPrenom(item) {
      return item.nomPrenom
        .toLowerCase()
        .includes(this.filterNomPrenom.toLowerCase());
    },
    async afficherPDF(item) {
      this.iframeSrc = await ApiFormComplementaireRepository.getDemandeFileDRH(
        item.id
      );

      this.dialogPDF = true;
    },
    minimumDate() {
      if (this.dateContratAgent) {
        if (
          new Date(this.dateContratAgent).getTime() >
          new Date("2022-01-01").getTime()
        ) {
          return new Date(this.dateContratAgent);
        }
        return new Date("2022-01-01");
      }
      return new Date(Date.now());
    },

    lancerMessagerie(item) {
      this.$refs.messagerie.openMessagerie(item);
      item.nombreMessagesUtilisateur = 0;
    },
  },
};
</script>
